import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import useThemeConfig from '../hooks/useThemeConfig';


export default function Theme({ children }) {
  const themeConfig = useThemeConfig();
  const theme = createTheme(themeConfig);
  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}